import React from 'react';
import { HStack, Text, VStack } from 'native-base';
import { OrdersTable } from './Table/OrdersTable';
import { Icon } from '../../Common/components/Icon';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons/faInfoCircle';
import {usePendingOrdersList} from "../hooks/usePendingOrdersList";

export function PendingDispenseNonQLD() {
    const { loading, orders } = usePendingOrdersList(false);

    const qldStates = ["QLD", "SA", "NT", "WA"];
    const nonQldOrders = orders.filter(x => !qldStates.includes(x.state??'') && !x.deliveryMethod?.startsWith('pickup'));
    return (
        <VStack space={2} flex={1}>
            <HStack space={2} alignItems={'center'}>
                <Icon icon={faInfoCircle} size={'sm'} />
                <Text>Non QLD Orders. Payment captured not dispensed</Text>
            </HStack>

            <OrdersTable orders={nonQldOrders} loading={loading} />
        </VStack>
    );
}
